module.exports = __webpack_public_path__ + "img/invoice-de.63fb556f.svg";